// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__isufS","navbar":"Welcome_navbar__H8HAv","video-container":"Welcome_video-container__Z9aff","full-height":"Welcome_full-height__ZPk9I"};